module.exports = __webpack_public_path__ + "static/media/talk03_small@3x.73fe9671.jpg";